import { useProjectParams } from '@hooks/useProjectParams';
import { useProjectData } from 'hooks/useProjectData';

import type { ReactNode } from 'react';
import { useMemo } from 'react';

import { ProjectPageLayout } from '../Layouts/ProjectPageLayout';

import { ActKC2GroupTypeSelector } from './components/ActKC2GroupTypeSelector';

import Style from './ActsKC2ListContainer.module.css';

export const ActsKC2ListContainer = <TTabs extends { id: TId | null; label: string } = any, TId = any>({
    tabElements,
    activeTabItem,
    workOrderTitle,
    currentOrderId,
    handleGroupChange,
    children,
}: {
    tabElements: TTabs[];
    activeTabItem: TTabs | null;
    workOrderTitle: string;
    currentOrderId: number;
    handleGroupChange: (value: TTabs) => void;
    children: ReactNode;
}) => {
    const { id: projectId, methodology } = useProjectParams();

    const { projectData } = useProjectData(projectId, false);

    const breadCrumbsItems = useMemo(
        () => [
            {
                label: projectData?.name,
                href: `/projects/${methodology}/${projectId}`,
            },
            {
                label: 'Договор',
                href: `/projects/${methodology}/${projectData?.uniqueId}/contract`,
            },
            {
                label: workOrderTitle,
                href: `/projects/${methodology}/${projectData?.uniqueId}/order/${currentOrderId}/`,
            },
        ],
        [currentOrderId, methodology, projectData?.name, projectData?.uniqueId, projectId, workOrderTitle],
    );

    return (
        <ProjectPageLayout
            title="Акты КС-2"
            breadCrumbsItems={breadCrumbsItems}
            classNameHeader={Style.headerBorder}
            style={{ height: 'calc(100% - 30px)' }}
        >
            <ActKC2GroupTypeSelector
                tabElements={tabElements}
                onChange={handleGroupChange}
                activeTabItem={activeTabItem}
            />
            {children}
        </ProjectPageLayout>
    );
};

ActsKC2ListContainer.displayName = 'ActsKC2ListContainer';
